import React, { Component } from 'react';
import { graphql, createFragmentContainer } from 'react-relay';
import { pick } from 'lodash';
import moment from 'moment';

import {
  StoreProvider,
  ImageUploader,
  DateTimePicker,
  ErrorFlash,
  Label,
} from '../../components';
import { END_OF_DAY } from '../constants';
import { createMessage } from '../../mutations';

import Field from './Field';
import 'react-datepicker/dist/react-datepicker.css';

export class MessageNewView extends Component {
  state = {
    title: '',
    externalUrl: '',
    pushNotificationText: '',
    body: '',
    callToAction: '',
    backgroundImage: null,
    endDate: moment(),
    errors: null,
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const { relay, lists } = this.props;
    const attributes = pick(this.state, [
      'title',
      'body',
      'backgroundImage',
      'externalUrl',
      'pushNotificationText',
      'callToAction',
    ]);
    attributes.endDate = this.state.endDate.toDate();

    createMessage(relay.environment, attributes, lists.id, {
      onCompleted: this.handleCompleted,
    });
  };

  handleCompleted = (response) => {
    const { errors } = response.createMessage;
    if (errors) {
      this.setState({ errors });
    } else {
      this.props.history.push('/messages/tab/active');
    }
  };

  handleChange = (name, value) => {
    this.setState({ [name]: value });
  };

  handleImageUploaded = (backgroundImage) => {
    this.setState({ backgroundImage });
  };

  handleDateChange = (endDate) => {
    this.setState({ endDate });
  };

  render() {
    const { errors, endDate } = this.state;
    return (
      <div className="message-new">
        <form className="message-form" onSubmit={this.handleSubmit}>
          <div className="form-header">
            <h2>Add Message</h2>
            <div className="form-header-actions">
              <input
                id="saveMessage"
                className="message-new-submit"
                type="submit"
                value="Save"
              />
            </div>
          </div>
          <div className="form-fields">
            <ErrorFlash errors={errors} />
            <div className="form-group">
              <h3>General</h3>
              <div className="form-group-fields">
                <div className="form-group-column">
                  <Field
                    name="title"
                    errors={errors}
                    attributes={this.state}
                    onChange={this.handleChange}
                    required
                  />
                  <Field
                    name="pushNotificationText"
                    labelText="Push Notification Text"
                    errors={errors}
                    attributes={this.state}
                    onChange={this.handleChange}
                  />
                  <Field
                    name="body"
                    errors={errors}
                    attributes={this.state}
                    onChange={this.handleChange}
                    element="textarea"
                    required
                  />
                  <Field
                    name="externalUrl"
                    labelText="External URL"
                    errors={errors}
                    attributes={this.state}
                    onChange={this.handleChange}
                  />
                  <Field
                    name="callToAction"
                    labelText="Call to action"
                    errors={errors}
                    attributes={this.state}
                    onChange={this.handleChange}
                  />
                </div>
                <div className="form-group-column">
                  <div className="input image-upload">
                    <Label attr="image" text="Image" errors={errors} />
                    <div className="image-upload-hint">
                      Image should be a .png or .jpg
                    </div>
                    <ImageUploader
                      id="backgroundImage"
                      onUploaded={this.handleImageUploaded}
                      type="message"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="form-group">
              <h3>Availability</h3>
              <div className="availability">
                <DateTimePicker
                  name="end"
                  datetime={endDate}
                  onChange={this.handleDateChange}
                  errors={errors}
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

const Container = createFragmentContainer(MessageNewView, {
  lists: graphql`
    fragment MessageNew_lists on Lists {
      id
    }
  `,
});

export default class MessageNew extends Component {
  render() {
    return (
      <StoreProvider
        container={Container}
        query={graphql`
          query MessageNewQuery {
            lists {
              ...MessageNew_lists
            }
          }
        `}
      />
    );
  }
}
